export const MILJO_BASEPATH = utledVanligMiljoFraUrl(window.location.origin);

function utledVanligMiljoFraUrl(url: string) {
    const miljoUrlInnlogget = (miljo: string) =>
        `https://personlig-kjennemerke${miljo}.atlas.vegvesen.no`;
    const miljoUrlAapen = (miljo: string) => `https://www.${miljo}vegvesen.no`;

    if (url.includes('localhost')) {
        return `http://localhost:8080`;
    }

    if (erInnlogget()) {
        if (erMiljo(url, 'utv')) {
            return miljoUrlInnlogget(`-${hentStmBackendUrl()}.utv`);
        } else if (erMiljo(url, 'test')) {
            return miljoUrlInnlogget('.test');
        } else if (erMiljo(url, '')) {
            return miljoUrlInnlogget('');
        }
    }

    if (erMiljo(url, 'utv')) {
        return miljoUrlAapen('utv.');
    } else if (erMiljo(url, 'test')) {
        return miljoUrlAapen('test.');
    } else if (erMiljo(url, '')) {
        return miljoUrlAapen('');
    }

    throw Error('Feil i parsing av miljø.');
}

function hentStmBackendUrl() {
    const erStmMiljo = (miljo: string) =>
        window.location.pathname.includes(`dinside/${miljo}`);
    if (erStmMiljo('alpha')) {
        return 'alpha';
    } else if (erStmMiljo('bravo')) {
        return 'bravo';
    } else if (erStmMiljo('charlie')) {
        return 'charlie';
    }
}

function erInnlogget() {
    return window.location.pathname.includes('dinside/');
}

function erMiljo(url: String, miljo: string) {
    return url.includes(miljo + '.vegvesen.no');
}

export function hentFellesLoggtjenesteUrl() {
    const url = window.location.origin;

    if (erMiljo(url, 'utv')) {
        return 'https://frontend-logger.utv.atlas.vegvesen.no';
    } else if (erMiljo(url, 'test')) {
        return 'https://frontend-logger.test.atlas.vegvesen.no';
    } else if (erMiljo(url, '')) {
        return 'https://frontend-logger.atlas.vegvesen.no';
    } else {
        return 'https://frontend-logger.utv.atlas.vegvesen.no';
    }
}
